import AccommodationCard from './AccommodationCard.styles.js';
export default AccommodationCard;
